import { Commodities } from "./Commodities";
import { ExportDeclaration } from "./ExportDeclaration";

export class InternationalDetail {
    Content: any; 
    Commodities: Commodities;  
    ExportDeclaration: ExportDeclaration;  
}